import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Spacing } from '../../enums/spacing'
import { pxToNumber } from '../../utils/pxToNumber'
import { SearchInputSize } from './SearchInput'

const BORDER_WIDTH = 1

interface SearchInputWrapperProps {
  size: SearchInputSize
  fullWidth: boolean
}

interface InputWrapperProps {
  fullWidth: boolean
}

export const SearchInputWrapper = styled.div<SearchInputWrapperProps>`
  display: flex;
  align-items: center;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
      min-width: 0;
    `}
`

export const InputWrapper = styled.div<InputWrapperProps>`
  margin-left: ${pxToNumber(Spacing.S2) + BORDER_WIDTH}px;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      flex: 1;
      min-width: 0;
    `}
`
